import { render, staticRenderFns } from "./transferislem.vue?vue&type=template&id=26ac66c1&"
import script from "./transferislem.vue?vue&type=script&lang=js&"
export * from "./transferislem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports